import dayjs from "dayjs";
import DateRangePicker from "../../ui/dateRangePicker";
import SalesWeeklyChart from "./ui/chart";
import SalesReportTableWeekly from "./ui/table";
import { useEffect, useState } from "react";
import { getReportSalesWeekly } from "../../../../service/report/sales";
import { RootState } from "../../../../modules";
import { useSelector } from "react-redux";
import SuperAdminPassword from "../../../../components/SuperAdminPassword";

const ReportSalesWeekly = () => {
    const [salesDailyChartData, setSalesDailyChartData] = useState<Array<ISalesReportData>>([])
    const { isSuperAdmin } = useSelector((state: RootState) => state.superAdmin);

    useEffect(() => {
        requestReportSalesWeekly(dayjs().subtract(6, 'week').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD'))
    }, [])


    const requestReportSalesWeekly = (startDate: string, endDate: string) => {
        getReportSalesWeekly(startDate, endDate)
            .then((res) => setSalesDailyChartData(res.data))
            .catch(error => console.error('error', error))
    }

    if (!isSuperAdmin) {
        return <SuperAdminPassword />
    }

    return <>
        <DateRangePicker
            startDate={dayjs().subtract(6, 'week')}
            onClick={(startDate: string, endDate: string) => requestReportSalesWeekly(startDate, endDate)} />
        <br /><br />
        {salesDailyChartData.length > 0 && <>
            <SalesWeeklyChart data={salesDailyChartData} />
            <SalesReportTableWeekly data={salesDailyChartData} />
        </>}
    </>
}
export default ReportSalesWeekly;

